// 按页面划分
export default {
    // 公共页面
    "common": {
        "title": "Dataganger",
        "pull_refresh": "Dra ner för att uppdatera",
        "release_refresh": "Släpp för att uppdatera",
        "refresh_loading": "Belastning…",
        "footer_text": "Tjänster tillhandahållna av Ucloudlink (NASDAQ: UCL)"
    },
    "home": {
        "input_placeholder": "Sökland/region",
        "my_flow": "Mina uppgifter",
        "charge_code": "Kupongkod",
        "coupons": "Kuponger",
        "local_package": "Lokaluppgifter",
        "more": "Mer",
        "popular_destination": "Land/region",
        "buy_now": "Köp nu",
        "package_useing": "Aktiv",
        "unused": "Inaktiv",
        "download_app": "Ladda ner appen",
        "enter_the_mall_list": "Gå till köpcentret",
        "no_data": "Inga data än",
        "no_data_available": "Inga data tillgängliga",
        "copy_success": "Kopiera framgång",
        "copy_fail": "Kopiera misslyckades",
        "meritsTitle": "Vilka är fördelarna?",
        "merits1": "Ingen SIM krävs & Inga månadskostnader",
        "merits2": "Integrerad med de 2-3 ledande operatörerna för automatisk nätverksbyte",
        "go_buy": "Köp nu",
        "instant_savings": "Spara",
        "expires_in": "Går ut om",
        "download_app_tips": "Ladda ner appen för fler erbjudanden och upplevelser"
    },
    "packages": {
        "sub_title": {
            "us": "Exklusive Guam, Saipan",
            "it": "Inklusive Vatikanstaden, San Marino",
            "va": "Inklusive Italien, San Marino",
            "sm": "Inklusive Italien, Vatikanens stad",
            "ma": "Inklusive Västsahara",
            "eh": "Inklusive Marocko",
            "ch": "Inklusive Liechtenstein",
            "li": "Inklusive Schweiz",
            "fr": "Inklusive Monaco",
            "mc": "Inklusive Frankrike",
            "fi": "Inklusive Aland Islands",
            "ax": "Inklusive Finland",
            "gu": "Inklusive norra Mariana -öar",
            "mp": "Inklusive Guam"
        },
        "unlimited_packages": "Obegränsat datapaket",
        "normal_packages": "Normalt datapaket",
        "multi_region_packages": "Flerregion",
        "regional_data": "Regional data",
        "high_speed_text": "höghastighetsdata",
        "infiniteFlow": "Obegränsad data",
        "unLimitData": "Obegränsad",
        "high_speed_text_year": "Hög hastighet/MP",
        "package_list": "Paketlista",
        "special_offer": "Erbjudanden",
        "first_month": "1:a Månad",
        "periodUnit": {
            "day": "dag",
            "month": "månad",
            "hour": "timmes",
            "year": "år"
        },
        "periodUnits": {
            "day": "dag",
            "month": "månad",
            "hour": "timmes",
            "year": "år"
        },
        "periodUnitSimp": {
            "day": "d",
            "month": "för",
            "hour": "h",
            "year": "yr"
        },
        "periodUnitMonthly":"Månatlig",
        "periodUnitsSimp": {
            "day": "d",
            "month": "för",
            "hour": "h",
            "year": "yr"
        },
        "unlimited_good_name": {
            "day": "Dagspass",
            "month": "Månadspass",
            "year": "Årspass"
        },
        "continuousMonth": "Kontinuerliga månader",
        "continuousDay": "Kontinuerliga dagar",
        "continuousYear": "Kontinuerliga år",
        "day_invalid": "Löper ut den aktuella dagen",
        "month_invalid": "Löper ut i den aktuella månaden",
        "immediate_valid": "Omedelbart",
        "tomorrow_day_valid": "Effektivt från nästa dag",
        "tomorrow_month_valid": "Effektivt från nästa månad",
        "detail": {
            "cell_flow": "Data",
            "cell_period": "Giltighet",
            "buy_quantity": "Belopp",
            "use_area": "Rapportering",
            "use_intro": "Villkor",
            "buy_btn": "Beställa",
            "pay": "Betala",
            "buy_tips": "Du har paketet %@packageName i användning. Vill du köpa det här paketet?",
            "haveOrderTips": "Order med väntande betalning skapad. Klicka Bekräfta för att gå till min datasida！"
        },
        "confirm": {
            "title": "Beställningsbekräftelse",
            "real_pay_amount": "Belopp som betalas",
            "online_payment": "Onlinebetalning",
            "create_order_error": "Inställningen misslyckades"
        }
    },
    "pay": {
        "result": {
            "loading_order_status": "Få orderstatus...",
            "buy_success": "Beställningen är klar",
            "buy_pending": "Väntande bekräftelse",
            "buy_pending_tip": "Betalning i processen...Om betalningen inte överfördes inom 10 minuter, vänligen kontakta oss för support.",
            "get_payment_info_fail": "Förvärv av betalningsinformation misslyckades",
            "cell_package": "Paket",
            "cell_buy_amount": "Delsumma",
            "cell_real_amount": "Belopp som betalas",
            "go_to_order_btn": "Gå till mitt paket",
            "back_home": "Tillbaka till hemmet",
            "back_mall": "Tillbaka till köpcentret",
            "ordersn_empty": "Beställ SN kan inte vara tom",
            "order_search_error": "Oväntat fel",
            "goodsName":'Produktnamn'
        },
        "fail": {
            "payment_fail": "Betalning misslyckades",
            "back_home": "Tillbaka till hemmet"
        }
    },
    "CountryGroup": {
        "title": "Land/region",
        "placeholder": "Sökland eller region",
        "clear": "Rensa",
        "history": "Sökhistorik"
    },
    "PromotionCode": {
        "verification": {
            "title": "Kupongkod",
            "minititle": "Kupongkod",
            "input": "Ange toppkoden",
            "explain": "Tips: Tryck på skanningsknappen längst upp till höger för att skanna QR -koden för kupongkortet, eller mata in manuellt kupongkoden (skiftlägeskänslig) om den inte fungerar.",
            "submit": "Överlämna",
            "exchange": "Återlösa",
            "cancel": "Avboka",
            "Inquiry": "Är du säker på att byta ut",
            "ErrorCode": "Laddningskodfel"
        },
        "recharge_success": {
            "package": "Paket",
            "content": "Framgångsrikt inlöst",
            "back": "Tillbaka till köpcentret",
            "view_packets": "Gå till mitt paket"
        }
    },
    "order": {
        "state": {
            "inUse": "Aktiverad",
            "isFirst": "Prioriterad",
            "toFirst": "Fastställa prioritet",
            "inactive": "Inaktiverad"
        },
        "periodUnits": {
            "minute": "minuter)",
            "hour": "timmes",
            "day": "dag",
            "month": "månad"
        },
        "useIntro": {
            "tip1": "Obegränsat datapaket har högre prioritet än volymdatapaket.",
            "tip2": "Användningsprioriteten kommer att baseras på inköpsdatum för samma typ av paket, dvs paketet med det tidigaste inköpsdatumet kommer att användas först, medan prioriteringen för enstaka-paket är högre än regionalt paket.",
            "tip3": "Du kan också justera prioriteringen för att använda paket av samma typ manuellt."
        },
        "myFlow": "Mina uppgifter",
        "remainingFlow": "Data kvar",
        "remainingTime": "Giltig vänster",
        "remainingHighFlow": "Höghastighetsdata kvar",
        "validPeriod": "Giltighet",
        "noneFlow": "Inget datapaket",
        "noneFlowTip": "Köp datapaketet och njut av det högkvalitativa nätverket",
        "buyPackFlow": "Köpa paket",
        "checkInvalidFlow": "Kontrollera utgången datapaket",
        "orderList":  {
            "title": "mina beställningar",
            "amount_paid": "Total",
            "device": "Ägd enhet",
            "order_details": "Beställningsinformation",
            "total_amont": "Delsumma",
            "orderSN": "Beställningsnr.",
            "createTime": "Skapande tid",
            "cancelTime": "Stängd tid",
            "payTime": "Beställningstid",
            "unsubTime": "Inställd tid",
            "payMethod": "Betalningsmetod",
            "thirdSN": "Transaktionsnr.",
            "delete": "Radera",
            "cancel": "Avbryt beställning",
            "unsub": "Återbetalning",
            "goto_cancel": "Vill du avbryta beställningen?",
            "goto_unsubscribe": "Vill du avregistrera beställningen?",
            "delete_Tips": "Beställningen kan inte återupptas efter att den tagits bort, därför kan dina efterserviceproblem inte hanteras.Är du säker på att ta bort den?",
            "status_success": "Avslutad",
            "status_pending": "Obetald",
            "status_cancel": "Stängd",
            "status_unsub": "Avbruten",
            "payMethod_stripe": "Kreditkort"
          },
    },
    "registerlogin": {
        "create_account_tip":"Skapa ett konto, börja exklusiv upplevelse",
        "select_country_tip":"Enhetsanvändning av land/region",
        "email_name": "Post",
        "phone_name": "Telefon",
        "email_address": "E -postadress",
        "password": "lösenord",
        "country": "land",
        "select_country": "Välj ett land",
        "cancel": "Avboka",
        "confirm": "Säker",
        "please_enter": "Ange 6-20 tecken (kombination av bokstäver, siffror eller symboler)",
        "select_country_tips": "Landsval är för att titta på lokala paket. Det kan inte ändras efter registrering. Bekräft!",
        "global_roaming": "Internationell domänkod",
        "phone_number": "telefonnummer",
        "agree": "komma överens",
        "user_agreement": "Användaravtal",
        "and": "och",
        "privacy_policy": "Integritetspolicy",
        "register_login": "Registrera dig eller logga in",
        "login_error": "Antalet inloggningar är för ofta, försök igen senare!",
        "register_error": "Antalet registreringar är för ofta, försök igen senare!",
        "forgot_pwd": "Glöm lösenordet",
        "app_tips": "Logga in på appen med det här kontot efter att ha laddat ner det för att få åtkomst till fler funktioner.",
        "download_app": "Gå för att ladda ner appen",
        "rememberPwd": "Kom ihåg lösenord",
        "third_login": "Fortsätta med",
        "agreement_tips": "Kontrollera rutan Användaravtal och sekretesspolicy",
        "selectCountry_tips": "Observera att det registrerade landet direkt kommer att påverka följande betalningsmetoder och valutor, välj enligt ditt behov.",
        "login_error_cancel": "Användaren avbröt inloggningen",
        "login_error_auth": "Tillåt pop-ups från webbläsarinställningarna",
        "device_tips": "Enhet väntar på aktivering. Bearbetas inom 24 timmar."
    },
    "forgotPwd": {
        "forgot_pwd": "Glöm lösenordet",
        "email_address": "E -postadress",
        "next": "Nästa",
        "email_has_been_sent": "Vi har skickat ett e -postmeddelande till %@email. Klicka på länken och följ stegen för att hämta ditt lösenord.",
        "have_retrieved_it": "Jag har hittat det",
        "unable_to_receive_email": "Kan du inte ta emot e -postmeddelandet? Kontrollera om det finns e -postmeddelanden från %@email under din skräppost och raderad e -postkatalog",
        "or": "eller",
        "resend": "Återgå",
        "global_roaming": "Internationell domänkod",
        "phone_number": "telefonnummer",
        "verification_code_has_been_sent": "Vi har skickat verifieringskoden till:",
        "verification_code": "Verifieringskod",
        "no_verification_code_received": "Fick inte verifieringskoden?",
        "please_enter": "Ange 6-20 tecken (kombination av bokstäver, siffror eller symboler)",
        "reset_password": "Återställa lösenord",
        "reset_successful": "Återställ framgångsrikt"
    },
    "coupons": {
        "coupons_name": "Kuponger",
        "no_coupons": "Inga kuponger än",
        "no_data": "Inga data än",
        "applicable_to_the_following": "Kuponger är lämpliga för följande datapaket"
    },
    "digital":{
        "title":"Enhet SN",
        "purchased":"Mina inköp",
        "viewAll":"Mer",
        "skinStore":"Produkt",
        "completed":"Köpt",
        "goBuy":"Köpa",
        "order": {
          "title":"Köpta beställningar"
        },
        "detail": {
          "describe":"Beskrivning"
        }
    },
    "viewPL": {
        "other": 'andra'
    },
    "invalidFlow": {
        "stateName": "Status",
        "state": {
            "NOT_ACTIVATED": "Inaktiverad",
            "IN_USING": "Tillgänglig",
            "USE_END": "Utmattad",
            "EXPIRE": "Uttogs",
            "TRANSFER": "Överföra",
            "UNSUBSCRIBE": "Avboka",
            "VALID": "Giltig",
            "INVALID": "Ogiltig",
            "EXCHANGE_POINTS": "Inlöser poäng"
        },
        "noneFlow": "Inget utgått datapaket",
        "pageName": "Utgått datapaket"
    },
    "flowDetail": {
        "title": "Datainformation",
        "flow": "Data",
        "validTime": "Giltiga startar",
        "invalidTime": "Giltig till",
        "coverage": "Rapportering",
        "useIntro": "Villkor",
        "purchaseTime": "Köpt på",
        "subtotal": "Delsumma",
        "status": "Status",
        "cancel": "Avboka",
        "buyAgain": "Köp det igen",
        "validity": "Giltighet",
        "tip": "Varsel",
        "cancelTip": "Är du säker på att du vill återbetala det här paketet?",
        "dataLeft": "Data kvar"
    },
    "netError": {
        "try_again": "Försök igen",
        "net_error": "Inget nätverk",
        "try_again_desc": "Kontrollera nätverksinställningen och försök igen"
    },
    "loadFail": {
        "try_again": "Försök igen",
        "load_fail": "Laddning misslyckades",
        "load_fail_desc": "Databelastning misslyckades, försök igen",
        "IMEI_Not_Exist": "IMEI finns inte, försök att komma in från den högra ingången",
        "Project_Not_Exist": "Ett fel uppstår. Kontakta kundservice. (01)",
        "commonError": "Ett fel uppstår. Vänligen kontakta kundservice."
    },
    "settlement_Easy_and_convenient": "Lätt och bekvämt",
    "settlement_Great_deal": "Mycket",
    "settlement_Safe_and_secure": "Säker och säker",
    "settlement_Autopay_service_regulation": "Reglering av automatiska betalningstjänster",
    "settlement_Read": "Läsa",
    "settlement_No_coupon": "Inga kuponger än",
    "settlement_Subtotal": "Delsumma",
    "settlement_Coupon": "Kupong",
    "settlement_TOTAL": "Total",
    "settlement_promotion_tip": "Kampanjbjudandet kan inte användas i samband med några kuponger",
    "settlement_coupon_tip": "Kupongen kan inte användas i samband med andra marknadsföringserbjudanden",
    "member_myFlow_noList": "Inga data än",
    "detail_se_content": "Ett säkert, enkelt och bekvämt sätt. Du kan avsluta prenumerationen när som helst",
    "Enter_Promo_code": "Marknadsföringskod",
    "Enter_Promo_Coupon": "Kuponger",
    "settlement_Not_used_coupon": "Kupong som inte används",
    "settlement_Available_coupon": "Tillgänglig",
    "settlement_Unavailable_coupon": "Inte tillgänglig",
    "please_Enter_Promo_code": "Ange kampanjkoden",
    "please_Select_Coupon_use": "Välj den kupong du vill använda.",
    "Buy_Now": "Köp nu",
    "Dont_Use_Any": "Använd inte någon",
    "settlement_confirm": "Bekräfta",
    "settlement_tips": "Bekräfta",
    "flowDetail_unsubscribe": "av sluta prenum",
    "flowDetail_unsubscribed": "Avbruten",
    "flowDetail_isCancelPackage": "Avsluta prenumerationen på detta paket?",
    "flowDetail_confirmAgreementUnsubscribe": "Du kan inte ha en hel del efter prenumerationen. Är du säker på att du vill avsluta prenumerationen?",
    "flowDetail_cancel": "Avboka",
    "flowDetail_cancelSuccess": "Avsluta prenumerationen framgångsrikt",
    "packages_detail_promotion": "Främjande",
    "orderTips":{
        "iDay" : "dag",
        "iDays" : "dagar",
        "iMonth" : "månad",
        "iMonths" : "månad",
        'First_charge_discount':"<label class='anyTime_Buy'>%@firstMoney</label>/%@periodSymbol på ditt första köp, betala %@money/%@periodSymbol senare, Du kan avsluta prenumerationen när som helst",
        'Monthly_discount':"Spara %@saveMoney varje %@period! Du kan avsluta prenumerationen när som helst",
        'Ordinary_monthly_package':"Ett säkert, enkelt och bekvämt sätt. Du kan avsluta prenumerationen när som helst",
        "AlreadyPurchased":'Ledsen att du bara kan prenumerera på ett datapaket just nu. Vänligen avsluta prenumerationen på “%@” och prenumerera senare på alla paket du önskar efter att det löper ut.',
        "Contract_recommendation_First":'<label>Med AutoPay -tjänst, endast på ditt första köp, betala bara</label>'
        +'<p class="money">%@firstMoney</p>'
        +'<p class="SubscribeTips">Du kan avsluta prenumerationen när som helst'
        +'<a class="btn">Prenumerera ></a></p>',
        "Contract_recommendation_Monthly_discount":"<label>Med autopay -tjänst, betala endast betala</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Du kan avsluta prenumerationen när som helst'
        +'<a class="btn">Prenumerera ></a></p>',
        "Contract_recommendation_General":"<label>Med autopay -tjänst</label>"
        +'<p class="money">%@money</p>'
        +'<p class="SubscribeTips">Ett säkert, enkelt och bekvämt sätt. Du kan avsluta prenumerationen när som helst'
        +'<a href="javascript:;" class="btn">Subscribe ></a></p>',
        'BanlanceDoubleCheck':'Är du säker på att du vill betala med balans?',
    },
    feedback: {
        title: "feed-back",
        placeholder: "Ange det land du vill besöka eller andra frågor, så uppfyller vi dina behov så snart som möjligt!",
        submit: "Skicka in",
        submit_success: "Inlämning lyckades",
        other_opinions: "Andra åsikter",
    },
    view_country_input: 'Ange ditt konto',
    select_package: {
        title: "Välj Data",
        allPackage: 'Alla Data',
        type: "Typ",
        flow: "Data",
        month_package: "Månadsplan",
        flow_package: "Datapakket",
        time: "Varaktighet",
        period: "Cykel",
        auto_debit: "Auto-Uttag Info",
        auto_subscribe: "Auto-Förlängning",
        detail: "Data Detaljer",
        carrier: "Stödjande Operatörer",
        country: "Täckta Länder",
        notice: "Köpsguide"
      }
}